import { checkSspUserUiConfigTranslations } from "ui/configuration/tools/common"
import { userEventModule } from "user/event"
import { isSystemAdmin } from "user/tools/permissions"
import { appEventModule } from "./event"
import { removeTokenInURL } from "./history/tools/common"
import { getStore } from "./store/store"
import { loadAppData, stopInitData } from "./tools/start"

export function startAppListeners(): void {
  const store = getStore()
  if (!store || !store.getState()) {
    appEventModule.on.storeReady("app-store-ready", () => removeTokenInURL())
  } else {
    removeTokenInURL()
  }
  userEventModule.on.login("campaign-start", async params => {
    if (!isSystemAdmin(params.userInfo)) {
      loadAppData(params.userInfo)
      checkSspUserUiConfigTranslations(params.userInfo)
    } else {
      // by default isInitializing === true in the state
      stopInitData()
    }
  })
}
